import { render, staticRenderFns } from "./SocialSignIn.vue?vue&type=template&id=d561283e&scoped=true&"
import script from "./SocialSignIn.vue?vue&type=script&lang=js&"
export * from "./SocialSignIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d561283e",
  null
  
)

export default component.exports